import Login from '../pages/Login';



// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    path: "/",
    exact: true,
    component: Login
  },
  {
    path: "/login",
    component: Login
  }

]